import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <main className="flex-1 pt-[80px] md:pt-[104px]">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
